export default __webpack_public_path__ + "static/media/misc-pantry1-768w.1bfd2f5a.webp";